import React from "react"
import styled from "@emotion/styled"
import RtlSvg from "@myvp/shared/src/icons/rtl-svg"
import { iconColorCss, IconProps } from "@myvp/shared/src/styles/icon-utils"

const Svg = styled(RtlSvg)`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;

  stop {
    stop-color: var(--color);
  }
`

const PdfDownload = (props: IconProps) => {
  const linearId1 = React.useId()
  return (
    <Svg
      focusable="false"
      className={props.className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={[iconColorCss(props.color)]}
    >
      <path
        d="M9 3V5H7L7 18H17V12H19V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V5C5 3.89543 5.89543 3 7 3H9Z"
        fill="var(--color)"
      />
      <path d="M13 13L9 13V12L13 12V13Z" fill="var(--color)" />
      <path d="M15 16L9 16V15L15 15V16Z" fill="var(--color)" />
      <path
        d="M13.2501 6.18934L11.0304 3.96967L9.96973 5.03033L14.0001 9.06066L18.0304 5.03033L16.9697 3.96967L14.7501 6.18934V1H13.2501V6.18934Z"
        fill={`url(#paint0_linear_${linearId1})`}
      />
      <path
        d="M19 10L19 9L9 9L9 10L19 10Z"
        fill={`url(#paint1_linear_${linearId1})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_${linearId1}`}
          x1="18.0304"
          y1="9.06066"
          x2="9.96973"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_${linearId1}`}
          x1="19"
          y1="10"
          x2="18.802"
          y2="8.0198"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </Svg>
  )
}

export default PdfDownload
